<template>
    <div class="seo-box">
        <Introduce :textData='textData' :companyData='companyData' class="black"></Introduce>
        <Service :serviceData='serviceData' class="black"></Service>
        <Hat :hatData='hatData' class="black"></Hat>
        <SeoTable class="black"></SeoTable>
        <DoBetter :childModle='childModleData' class="black"></DoBetter>
    </div>
</template>
<script>
    import Introduce from '@/components/main/home/introduce'//引入公司介绍
    import Service from '@/components/main/project/service'//引入服务介绍
    import Hat from '@/components/main/project/hat'//引入说明布局
    import SeoTable from '@/components/main/project/seotable'//引入seo表格说明
    import DoBetter from '@/components/main/contact/dobetter'//引入图文    
    export default {
        name: 'Seo',
        data() {
            return {
                textData: ['Search Engine Optimization'],
                childModleData: {
                    center: '具体服务内容依据不同行业、公司网站基础以及客户需求当然会有不同安排和侧重。下面是常规的SEO顾问服务内容',
                    title: 'SEO服务内容',
                    ulData: ['行业及竞争对手研究', '外部链接建设建议书', '关键词研究', '网站优化执行监督', '网站详细诊断', '日常SEO有关问题咨询', '网站SEO报告及优化建议书', '公司网站运营']
                },
                companyData: {
                    title: 'Marketing Service',
                    caption: 'SEO优化',
                    chinese: ['<p class="text-center">SEO全名Search Engine Optimization 搜索引擎优化，是透过了解搜索引擎(如Google、Yahoo)规则来调整网站内容配置，以提高网站在搜索引擎中排名的方式，因为在搜索引擎查询的用户，往往只会注意第一页前几条的网站，因此要成为知名的网站，一定要了解如何针对搜索引擎作最佳的优化。</p>'],
                    english: '<p>Search engine optimization (SEO) is the process of helping your customers connect with your business online.</p><p>Our team uses modern SEO services, backed by the best digital practices, to increase your traffic & rankings for vetted keywords and long-tail phrases that drive business to your site.</p>'
                },
                hatData: {
                    title: '数字化营销服务',
                    caption: '白帽SEO  抢占先机',
                    chinese: '<p>我们检查任何影响网站SEO排名的因素并整改，通过第三方SEO优化工具，如SEOquake进行专业检测，如robots，站点地图，网址标题，描述，H1标签，结构化数据等</p><p>并且按照SEO规则对其进行逐一的优化，让Google能够更容易抓取收录您的网站</p>',
                },
                serviceData: {
                    caption: '您将通过SEO服务得到什么？',
                    center: '到目前为止，搜索引擎依然是网站流量的最大来源，SEO依然是最有效的网络营销手段。我们的SEO服务帮助您全面提升网站搜索引擎排名表现，提升关键词排名，带来自然流量，进而提升公司销售和利润。',
                    itemData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-248343203.jpg',
                            caption: '高效的SEO诊断和建议'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/3b21b897513257.5ec6aad35765d.jpg',
                            caption: '整站优化策略'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/2616398eaa72270b9f4ccca27ffb335c.jpg',
                            caption: '符合搜索引擎质量指南的优化技术'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/10fb3287111845.5dae4605c87af.jpg',
                            caption: '最精准的网站目标流量'
                        }
                    ]
                }
            }
        },
        components: {
            Introduce,
            Service,
            Hat,
            SeoTable,
            DoBetter
        }
    }
</script>
<style scoped>
    .introduce-box>>>.carBoxbottom,
    .introduce-box>>>.carBox {
        display: none;
    }

    .introduce-box>>>.carBanner {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
    }

    .introduce-box>>>.marquee-text {
        padding: 0;
        transform: translateY(70%);
    }

    .introduce-box {
        margin-top: 251px;
        height: 550px;
        padding: 0;
        margin-bottom: 200px;
    }

    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.center-box {
        width: 59.4%;
        height: 777px;
        padding-left: 249px;
    }

    .DoBetter>>>.center-box::after {
        width: 575px;
        height: 737px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/8259019d3ef70c373be081e011404779.jpg') no-repeat 82% bottom;
        background-attachment: fixed;
        /* background-size: cover; */
        top: 137px;
        right: -530px;
    }

    .DoBetter>>>.animetionLine,
    .seo-box>>>.DoBetter::before {
        display: none;
    }

    .DoBetter>>>.center-box::before {
        content: 'college';
        transform: rotate(90deg) translate(22%, -115px);
    }

    .DoBetter>>>.center-box {
        padding: 0 10%;
    }

    .DoBetter>>>.title-caption {
        font-size: 42px;
        font-weight: bold;
        line-height: 59px;
        color: rgba(51, 51, 51, 1);
        position: relative;
        margin-bottom: 44px;
    }

    .DoBetter>>>.text-center {
        max-width: 600px;
    }

    .DoBetter>>>.title-caption::before {
        content: '数字化营销服务';
        display: block;
        text-transform: uppercase;
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .DoBetter>>>.text-ul {
        display: grid;
        width: 100%;
        grid-column-gap: 155px;
        grid-template-columns: 1fr 1fr;
        margin-top: 52px;
        padding-left: 15px;
    }

    .DoBetter>>>.text-li {
        padding-bottom: 26px;
        font-size: 16px;
        font-weight: bold;
        color: #2488F8;
        list-style-type: disc;
    }

    .DoBetter>>>.text-li>h5 {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
    }

    .seo-box>>>.hat-box {
        width: 58.8%;
        height: 34.11vw;
    }

    .hat-box>>>.center-box {
        width: 71%;
        right: 0;
        transform: translate(80%, -30%);
    }

    .hat-box>>>.left-center-box {
        padding: 5%;
    }

    @media(max-width: 995px) {
        .seo-box>>>.introduce-box {
            margin: 0;
            height: auto;
        }

        .introduce-box>>>.carBanner {
            position: static;
            transform: translate(0%, 0%);
            z-index: 3;
        }

        .seo-box>>>.hat-box {
            width: 100%;
            margin-top: 0;
            height: auto;
        }

        .hat-box>>>.center-box {
            position: static;
            width: 100%;
            transform: translate(0%, 0%);
        }

        .hat-box>>>.left-center-box {
            max-width: 100%;
            padding: 5%;
        }

        .hat-box>>>.caption {
            font-size: 24px;
            line-height: 100%;
            margin: 5% 0;
        }

        .DoBetter>>>.center-box {
            width: 100%;
            padding: 5%;
            height: auto;
        }

        .seo-box>>>.DoBetter {
            padding: 0;
        }

        .DoBetter>>>.text-center {
            max-width: 100%;
            padding: 0;
        }

        .DoBetter>>>.text-ul {
            grid-column-gap: 10%;
            grid-template-columns: 1fr;
            margin-top: 5%;
            padding-left: 15px;
        }
        .DoBetter>>>.title-caption {
        font-size: 24px;
        line-height: 140%;
        position: relative;
        margin-bottom: 5%;
    }
    .DoBetter>>>.title-caption::before {
       
        position: static;
        transform: translateY(0%);
        font-size: 16px;
        line-height: 137%;
    }
    }

    /* @media(max-width: 1023px) {
        .introduce-box {
            height: 1550px;
        }

        .DoBetter>>>.center-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/8259019d3ef70c373be081e011404779.jpg') no-repeat center;
            background-attachment: initial;
            background-size: cover;
            width: 100%;
            height: 1500px;
            padding: 5%;
            justify-content: center;
        }

        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.text-center {
            transform: translateY(0%);
            background-color: rgba(255, 255, 255, .98);
        }

        .DoBetter>>>.text-ul {
            margin-top: 0;
            padding: 5%;
            width: 100%;
            background-color: rgba(255, 255, 255, .98);
        }

        .DoBetter>>>.text-li {
            font-size: 50px;
        }

        .DoBetter>>>.text-li>h5 {
            font-size: 50px;
            font-weight: normal;
        }

        .DoBetter>>>.title-caption {
            font-size: 75px;
            line-height: 140%;
            transform: translateX(150%);
            margin-bottom: 0;
        }

        .DoBetter>>>.title-caption::before {
            font-size: 50px;
        }
    }

    @media(max-width: 418px) {
        .introduce-box {
            height: 2550px;
        }

        .introduce-box>>>.carBanner {
            width: 100%;
        }
        .DoBetter>>>.center-box {
            height: 2500px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/porject/seo.vue